/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accLinkActions', ['template', function(template) {
        return {
            scope: {
                node: '=accLinkActions',
                linksTable: '='
            },
            templateUrl: template('links/_actions'),
            controller: ['$scope', 'NodeShareLink', function($scope, NodeShareLink) {
                $scope.revokeAll = function() {
                    NodeShareLink.removeAll({node_uuid: $scope.node['uuid']}, function() {
                        $scope.linksTable.reload();
                    });
                }
            }]
        }
    }]);
